<label *ngIf="label">
  <span>
    {{ label }}
    <span *ngIf="required" class="required">*</span>
  </span>
  <button
    *ngIf="actionText"
    class="rv-link"
    type="button"
    (click)="action.emit()"
  >
    {{ actionText }}
  </button>
  <riv-help *ngIf="help" [help]="help" [size]="12"></riv-help>
</label>
<div class="content"><ng-content></ng-content></div>
